export const publicVersion = "2.5.2-0-gad45eeb-2026-03-06T12-20-46Z";